import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { USER_MGMT_CNST } from '../../../../constants/proj.cnst';
import { isNullOrUndefined } from '../../../../modules/shared';
import { AppStateService } from '../../../../services/app-state.service';
import { DataService } from '../../../../services/data.service';
import { EnvService } from '../../../../services/env.service';
import { HttpService } from '../../../../services/http.service';
import { UtilsService } from '../../../../services/utils.service';
import { MatStepper } from '@angular/material/stepper';
import { MatAccordion } from '@angular/material/expansion';

@Component({
  selector: 'lib-role-config',
  templateUrl: './role-config.component.html',
  styleUrls: ['./role-config.component.scss']
})
export class RoleConfigComponent implements OnInit, OnDestroy {
  @ViewChild('stepper') stepper!: MatStepper;

  stepConfig: {
    info: number,
    resources: number,
    scope: number
  } = {
    info: 1,
    resources: 0,
    scope: 0
  };

  searchApi!: string;
  searchWidget!: string;
  searchDashboard!: string;
  searchUrl!: string;

  searchConfig!: {
    api: string,
    widget: string,
    dashboard: string,
    url: string
  };

  profileData: any = {};
  isFormNotValid: boolean = true;
  isNameTouched: boolean = false;
  isRoleNameNotValid : boolean = false;

  operation:any;
  title:any;
  userMetaInfo: any;
  applicationList: any[] = [];

  scopeScreenVisible: boolean = false;
  currentTab: string = 'info';
  currentTabIndex :number = 0;
  roleId: any = null;
  customerDetails: any;

  roleDetailsJson: any = {};
  initScope: any[] = [];
  updatedRoleScope: any[] = [];

  initialResourceActionIdsBackup: any[] = [];
  scopeEndPoint: string = '';
  resourceList: any = null;
  actionColumns: any[] = [];
  mappedResourcesListToRole: any[] = [];
  resourcesListOfApplication: any[] = [];
  resourceTypes: string[] = [];
  initialResourceActionIds: any[] = [];

  subscriptions : Subscription[] = [];

  globalResourceCheck: boolean = true;
  initialApplicationId : any = null;
  intialResources: any = null;
  deleteResource: any[] = [];
  actionNameMapping: any = USER_MGMT_CNST.ACTION_NAME_MAPPING
  loading: boolean = true;
  isScopeValid:boolean = true;

  nextStepValidForm = new FormGroup({
    nextStepValid: new FormControl('',[Validators.required]),
  });
  nextStepAssignResource = new FormGroup({
    nextStepValid: new FormControl('',[Validators.required]),
  });

  roleNameForm = new FormGroup({
    roleName: new FormControl('',[Validators.required]),
  });
  roleApplicationNameForm = new FormGroup({
    applicationName: new FormControl('',[Validators.required]),
  });
  productStandardAppsIds = USER_MGMT_CNST.PRODUCT_STANDARD_APPLICATION_IDS;
  resourceApiInProgress:boolean = false;

  @ViewChild('widgetsAccordion') widgetsAccordion!: MatAccordion;
  @ViewChild('dashboardsAccordion') dashboardsAccordion!: MatAccordion;

  constructor(
    private httpSrv: HttpService,
    private utilsSrv: UtilsService,
    private appStateSrv: AppStateService,
    private envService : EnvService,
    private dataSrv : DataService,
    private router: Router,
    private activateRoute : ActivatedRoute
  ) { }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription : Subscription) => subscription.unsubscribe());
  }

  ngOnInit(): void {

    const queryParamRef = this.activateRoute.queryParams.subscribe(async (params: any) => {
      this.loading = true;
      const isProfileDataExists = this.utilsSrv.isObjectNotNullAndEmpty(this.appStateSrv.getProfileData());
      this.customerDetails = this.appStateSrv.getCurrentCustomerInfo();
      this.operation = params['operation'];
      this.title = params?.title
      this.resourceList = null
      
      if(this.operation == USER_MGMT_CNST.ROLE_MODULE_OPERATIONS.ADD_ROLE) {

      }else if(this.operation == USER_MGMT_CNST.ROLE_MODULE_OPERATIONS.UPDATE_ROLE || this.operation == USER_MGMT_CNST.ROLE_MODULE_OPERATIONS.VIEW_ROLE) {
        let roleId = params['roleId'];
        const obj = {"nextStepValid":'yes'};
        this.nextStepValidForm.patchValue(obj);
        this.roleId = roleId;
        let roleData: any;
        if (!isProfileDataExists){
          const options = {
            'uriParams': {
              roleId
            }
          }
          let roleInfo = await this.dataSrv.getRoleInfoById(options);
          if (this.utilsSrv.isObjectNotNullAndEmpty(roleInfo)) {
            const { response } = roleInfo;
            roleData = response;
            this.initialApplicationId = response.applicationId
          }
        }else {
          const { info } = this.appStateSrv.getProfileData();
          roleData = info;
        }
        if (this.utilsSrv.isObjectNotNullAndEmpty(roleData)) {
          this.buildProfileData(roleData);
          this.roleDetailsJson = roleData.roleDetailsJson || { validScopes: [] };
          this.initScope = this.roleDetailsJson.validScopes || [];
        }else {
          const options = {
            'uriParams': {
              roleId
            }
          }
          let roleInfo = await this.dataSrv.getRoleInfoById(options);
          if (this.utilsSrv.isObjectNotNullAndEmpty(roleInfo)) {
            const { response } = roleInfo;
            roleData = response;
            this.initialApplicationId = response.applicationId;
            this.buildProfileData(roleData);
            this.roleDetailsJson = roleData.roleDetailsJson || { validScopes: [] };
            this.initScope = this.roleDetailsJson.validScopes || [];    
          }
        }
        
      }
      const tabs = Object.keys(this.stepConfig);
      if (params['config'] && tabs.includes(params['config'])) {
          this.currentTab = params['config'];
          tabs.forEach((tab: string, index: number) => {
            if (tab == params['config']) {
              this.currentTabIndex = index;

              this.stepConfig[tab as keyof typeof this.stepConfig] = 1;
            } else {
              this.stepConfig[tab as keyof typeof this.stepConfig] = 0;
            }
          })
        }
      this.userMetaInfo = this.appStateSrv.getUserMetaInfo();
        this.loadApplications();
      this.loading = false;
    });
    this.subscriptions.push(queryParamRef);
  }

  onToggleTab(event: any) {
    const tabs = Object.keys(this.stepConfig);
    const steps = ['info','resources','scope']

    if(this.roleId) {
      this.currentTab = steps[event?.selectedIndex];
      tabs.forEach((tabs: any) => {
        if(tabs === steps[event?.selectedIndex]) {
          this.stepConfig[tabs as keyof typeof this.stepConfig] = 1;
          this.router.navigate(['um','roles','config'], {
            queryParams: {
              config: steps[event?.selectedIndex]
            },
            queryParamsHandling: 'merge'
          })
        }else {
          this.stepConfig[tabs as keyof typeof this.stepConfig] = 0;
        }
      });
    }
    this.searchApi = '';
    this.searchWidget = '';
    this.searchDashboard = '';
    this.searchUrl = '';
    this.expandAllWidgets = 'closed';
    this.expandAllDashboards = 'closed';
  }

  onlyAlphabet(event: any) {
    const pattern = /^[a-zA-Z0-9\s]+$/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  space(event: any){
    if(event.target.selectionStart === 0 && event.code === 'Space'){
      event.preventDefault();
    }
  }

  inputHasOnlyAlphabets(event: any) {
    let inputText = event.target.value;
    this.isNameTouched = true;
    this.isFormNotValid = inputText.length > 0 ? false : true;
    this.profileData.firstName = inputText;
  }

  buildProfileData(response : any) {    
    let { roleName, applicationId, description, applicationName, customerName } = response;

    this.profileData['firstName'] = roleName;
    this.profileData['selectedApplication'] = applicationId;
    this.profileData['applicationName'] = applicationName;
    this.profileData['description'] = description;
    this.profileData['customerName'] = customerName;
    this.roleNameForm.controls.roleName.setValue(roleName ? roleName:'');
    this.roleApplicationNameForm.controls.applicationName.setValue(applicationId ? applicationId :'');
  }

  loadApplications() {
    this.loading = true;
    this.httpSrv.makeGetApiCall('APP_LIST',this.envService.baseUrl).subscribe({
      next: (response : any) => {
        this.applicationList = response;
        if(this.roleId) {
         this.applicationChange();
        }
      },
      complete: () => {this.loading = false;},
      error: () => {
        this.applicationList = []
      }
    });
  }

  applicationValueChanged(event:any) {
    this.profileData['selectedApplication'] = event.value;
    if(this.operation == USER_MGMT_CNST.ROLE_MODULE_OPERATIONS.UPDATE_ROLE) {
      this.isFormNotValid = false;
    }
  }

  applicationChange() {
    
    this.scopeEndPoint = '';

    let applicationId = this.profileData.selectedApplication;
    
    //* Store a backup of the resource action ids of the initial resource
    //* which was loaded so that when application is switched we can track
    //* and compare if some of these ids are to be moved to deleted array
    if (this.initialResourceActionIdsBackup.length === 0) {
      this.initialResourceActionIdsBackup = [...this.initialResourceActionIds];
    }
    
    const selectedApplicationInfo = this.applicationList.find((app: any) => app.applicationId == this.profileData.selectedApplication);
    
    if(selectedApplicationInfo) {
      this.scopeEndPoint = selectedApplicationInfo.scopeEndPoint || '';
    }

    const tabs = Object.keys(this.stepConfig);
    const that = this;
    if(this.currentTab && tabs.includes(this.currentTab)){
      tabs.forEach((tab: string) => {
        if(tab == this.currentTab) {
          this.stepConfig[tab as keyof typeof that.stepConfig] = 1;
        }else {
          this.stepConfig[tab as keyof typeof that.stepConfig] = 0;
        }
      });
    }

    // TODO: Enable this for scope.
    // this.fetchScopeTypes();
    let options = {
      queryParams:{
        applicationId: this.profileData.selectedApplication,
        applicationName: this.profileData.applicationName
      }
    };
    const roleOptions = {
      replaceParams: {
        REPLACE_ROLE_ID: this.roleId,
      },
    }

    this.resourceList = null;
    this.intialResources = null;
    this.actionColumns = [];
    this.mappedResourcesListToRole = [];
    this.resourcesListOfApplication = [];
    this.loading = true;
    this.resourceApiInProgress = true;
    this.httpSrv.makeGetApiCall('FETCH_ALL_RESOURCES_UNDER_APPLICATION', this.envService.product_baseUrl,options).subscribe({
      next:async (appResources: any) => {
        this.resourcesListOfApplication = appResources && appResources.response ?  appResources.response : [];
        this.mappedResourcesListToRole = [];
       await this.httpSrv.makeGetApiCall("ROLE_RSC_LIST", this.envService.baseUrl, roleOptions).subscribe({
          next: (roleResource: any) => {
            this.mappedResourcesListToRole = roleResource && roleResource.response ?  roleResource.response : [];
            this.resourceList = this.formatResponse(this.resourcesListOfApplication);
            this.intialResources = this.formatResponse(this.resourcesListOfApplication);
            this.initialResourceActionIds = this.storeRsrcActionIds(true);
          },
          complete: () => {
            this.loading = false;
            this.resourceApiInProgress = false;
          },
          error: () => {
            this.loading = false;
          }
        });
      },
      complete: () => {this.resourceApiInProgress = false;},
      error: () => {
        this.loading = false;
        this.resourceList = this.formatResponse(this.resourcesListOfApplication);
        if(this.operation == USER_MGMT_CNST.ROLE_MODULE_OPERATIONS.UPDATE_ROLE) {
          this.isFormNotValid = false;
        }
      }
    });
  }

  formatResponse(data: any[]) {    
    let resourceTypeDataMap: {
      "APIs": any[],
      "URLs": any[],
      "Dashboards": any[],
      "Widgets": any[]
    } = {
      "APIs": [],
      "URLs": [],
      "Dashboards": [],
      "Widgets": []
    };
    
    this.resourceTypes = USER_MGMT_CNST.RESOURCE_TYPES;
    if(Array.isArray(data)) {
    for(let row of data) {
      let filterData = this.mappedResourcesListToRole.find((r: any) => r.resourceId === row.resourceId);
      for(let action of row.actionsInfo) {
        if(filterData) {
          let actionMapping = filterData.actionsInfo.find((a: any) => a.resourceActionId === action.resourceActionId);
          action['isAssigned'] = actionMapping ? true: false;
        }else {
          action['isAssigned'] = false;
        }
        if(row.resourceTypeName){
          const index = resourceTypeDataMap[row.resourceTypeName as keyof typeof resourceTypeDataMap].findIndex((r: any) => r.resourceId === row.resourceId)
          if(index == -1) {
            resourceTypeDataMap[row.resourceTypeName as keyof typeof resourceTypeDataMap].push(row);
          }
        }else {
          const index = resourceTypeDataMap['Dashboards'].findIndex((r: any) => r.resourceId === row.resourceId);
          if(index == -1) {
            resourceTypeDataMap['Dashboards'].push(row);
          }
        }
      }
    }
    }else{

      for(let key of Object.keys(data)) {
        let resourceObjs : any[] = data[key];
        for(let resource of resourceObjs) {
          if(key == 'Dashboards') {
            let pages = []
            for(let resourceitem of resource.pages) {
              let filterData = this.mappedResourcesListToRole.find((r: any) => r.resourceId === resourceitem.resourceId);
              for(let action of resourceitem.actionsInfo) {
                if(filterData) {
                  let actionMapping = filterData.actionsInfo.find((a: any) => a.resourceActionId === action.resourceActionId);
                  action['isAssigned'] = actionMapping ? true: false;
                }else {
                  action['isAssigned'] = false;
                }
                 const index : any = pages.findIndex((r: any) => r.resourceId === resourceitem.resourceId)
                    if(index !== -1) {
                    pages[index] = resourceitem;
                    } else {
                    pages.push(resourceitem); 
                    }
                
              }
            }

             let forms = []
            for(let resourceitem of resource.forms) {
              let filterData = this.mappedResourcesListToRole.find((r: any) => r.resourceId === resourceitem.resourceId);
              for(let action of resourceitem.actionsInfo) {
                if(filterData) {
                  let actionMapping = filterData.actionsInfo.find((a: any) => a.resourceActionId === action.resourceActionId);
                  action['isAssigned'] = actionMapping ? true: false;
                }else {
                  action['isAssigned'] = false;
                }
                    const index : any = forms.findIndex((r: any) => r.resourceId === resourceitem.resourceId)
                    if(index !== -1) {
                    forms[index] = resourceitem;
                    } else {
                    forms.push(resourceitem); 
                    }
              }
            }

            resourceTypeDataMap['Dashboards'].push({
              page_name: resource.page_name,
              pages: pages,
              forms: forms
            });
          }else if(key == 'Widgets') {
            let widgets = []
            for(let resourceitem of resource.Widgets) {
              let filterData = this.mappedResourcesListToRole.find((r: any) => r.resourceId === resourceitem.resourceId);
              for(let action of resourceitem.actionsInfo) {
                if(filterData) {
                  let actionMapping = filterData.actionsInfo.find((a: any) => a.resourceActionId === action.resourceActionId);
                  action['isAssigned'] = actionMapping ? true: false;
                }else {
                  action['isAssigned'] = false;
                }
                const index : any = widgets.findIndex((r: any) => r.resourceId === resourceitem.resourceId)
                    if(index !== -1) {
                    widgets[index] = resourceitem;
                    } else {
                    widgets.push(resourceitem); 
                    }
              }
            }
            resourceTypeDataMap['Widgets'].push({
              page_name: resource.page_name,
              Widgets: widgets
            });
          }
        }
      }
    }
    return resourceTypeDataMap;
  }
  

  onFormSubmit(form: NgForm) {
    //*If description was not entered set it to blank string
    form.value.description = isNullOrUndefined(this.profileData.description) ? '' : this.profileData.description;
    form.value.name = isNullOrUndefined(this.profileData.firstName) ? '' : this.profileData.firstName;
    form.value.application = isNullOrUndefined(this.profileData.selectedApplication) ? '' : this.profileData.selectedApplication;
    let customerDetails = {};
    if(this.userMetaInfo && this.userMetaInfo['customerId'] && this.userMetaInfo['customerName']){
      const obj = {"nextStepValid":'yes'};
      this.nextStepValidForm.patchValue(obj);
      customerDetails = {
        customerId: this.userMetaInfo['customerId'],
        customerName: this.userMetaInfo['customerName']
      }
    }else{
      const obj = {"nextStepValid":'yes'};
      this.nextStepValidForm.patchValue(obj);
      customerDetails = {
        customerId: null,
        customerName: null
      }
    }

    this.addProfile(form.value, customerDetails);
  }

  addProfile(profileInfo: any,customerDetails: any) {
    let { name, description, application } = profileInfo;

    let postData = {
      "meta": {
        roleName: name,
        description: description,
        applicationId: application,
        customerId: customerDetails['customerId']
      }
    };
    this.loading = true;
    this.httpSrv.makePostApiCall("ADD_PROFILE", postData, this.envService.baseUrl).subscribe({
        next: (response: any) => {
          if (response.statusCode === 201) {
            this.roleId = response.response;
            this.utilsSrv.showToastMessage(response.message, "success");
            this.router.navigate(['um', 'roles', 'config'], {
              queryParams: {
                operation: USER_MGMT_CNST.ROLE_MODULE_OPERATIONS.ADD_ROLE,
                config: 'resources',
                roleId: this.roleId,
                title:this.title == 'add' ? 'add' :'edit'
              }
            })
          }
        },
        complete: () => {this.loading = false;},
        error: (err: any) => {
          let { error } = err;

          if (this.utilsSrv.isObjectNotNullAndEmpty(error)) {

            if (error.message.includes("roles_role_name_application_id_key")) {
              this.utilsSrv.showToastMessage("Role name exists", "error");
            } else {
              this.utilsSrv.showToastMessage("Error occured while creating role", "error");
            }
          } else {
            this.utilsSrv.showToastMessage("Error occured while creating role", "error");
          }
        }
      });
  }


  selectAll(type: string, searchString: string) {
    this.deleteResource = [];

    const isLinear = this.resourceList?.[type].length > 0 && this.resourceList[type][0]?.resourceId;
    const resourceData = isLinear ? this.resourceList : this.resourceList;

    // Short-circuit if type not found
    if (!resourceData || !resourceData[type]) return;

    if (isLinear ) {
      // Old flat format
      const filteredResources = searchString
        ? resourceData[type].filter((resource: any) =>
            resource.resourceName?.toLowerCase().includes(searchString.toLowerCase()))
        : resourceData[type];

      for (const resource of filteredResources) {
        for (const action of resource.actionsInfo || []) {
          action.isAssigned = true; 
        }
      }
      
    } else {
      // If new nested format — we also need to drill down into metadata
      this.toggleAllPanels(type,'opened');
      const metadataBlocks = this.resourceList[type];
      if(Array.isArray(metadataBlocks)) {
        for(const resourceObj of metadataBlocks) {
          for (const block of Object.keys(resourceObj)) {
            if(Array.isArray(resourceObj[block])) {
              for (const resource of resourceObj[block]) {
                if (!searchString || resource.resourceName?.toLowerCase().includes(searchString.toLowerCase())) {
                  for (const action of resource.actionsInfo || []) {
                    if(!action.isAssigned){
                      action.isAssigned = true;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  expandAllDashboards: string = 'closed';
  expandAllWidgets: string = 'closed';
  toggleAllPanels(type:string,action:string) {
    if(action === 'opened'){
      this.openAll(type);
    }else{
      this.closeAll(type);
    }
    if(type === 'Widgets'){
      this.expandAllWidgets = action;
    }else{
      this.expandAllDashboards = action;
    }

  }
  openAll(type:string) {
    if(type === 'Widgets'){
     this.resourceList['Widgets'].forEach((resource:any) => resource.expanded = true);
    }else{
      this.resourceList['Dashboards'].forEach((resource:any) => resource.expanded = true);
    }

}

closeAll(type:string) {
  if(type === 'Widgets'){
     this.resourceList['Widgets'].forEach((resource:any) => resource.expanded = false);
    }else{
      this.resourceList['Dashboards'].forEach((resource:any) => resource.expanded = false);
    }

}

  clearAll(type: string, searchString: string) {
    const isLinear = this.resourceList?.[type].length > 0 && this.resourceList[type][0]?.resourceId;
    const resourceData = isLinear ? this.resourceList : this.resourceList;

    // Short-circuit if type not found
    if (!resourceData || !resourceData[type]) return;

    if (isLinear) {
      // Old flat format
      const filteredResources = searchString
        ? resourceData[type].filter((resource: any) =>
            resource.resourceName?.toLowerCase().includes(searchString.toLowerCase()))
        : resourceData[type];

      for (const resource of filteredResources) {
        for (const action of resource.actionsInfo || []) {
          action.isAssigned = false;
          this.deleteResource.push(action.resourceActionId);
        }
      }
    } else {
      // If new nested format — we also need to drill down into metadata
      this.toggleAllPanels(type,'opened');
      const metadataBlocks = this.resourceList[type];
      if(Array.isArray(metadataBlocks)) {
        for(const resourceObj of metadataBlocks) {
          for (const block of Object.keys(resourceObj)) {
            if(Array.isArray(resourceObj[block])) {
              for (const resource of resourceObj[block]) {
                if (!searchString || resource.resourceName?.toLowerCase().includes(searchString.toLowerCase())) {
                  for (const action of resource.actionsInfo || []) {
                    action.isAssigned = false;
                    this.deleteResource.push(action.resourceActionId);
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  getFilteredWidgets(resource: any, search: string): any[] {
  if (!resource?.Widgets) return [];
    return resource.Widgets.filter((widget: any) =>
     widget.resourceName?.toLowerCase().includes(search?.toLowerCase() || '')
  );
  }

  getFilteredDashboardsPages(resource:any,search:any):any[] {
    if (!resource?.pages) return [];
    return resource.pages.filter((resource: any) =>
     resource.resourceName?.toLowerCase().includes(search?.toLowerCase() || '')
    );
  }

  getFilteredDashboardsForms(resource:any,search:any):any[] {
    if (!resource?.forms) return [];
    return resource.forms.filter((resource: any) =>
     resource.resourceName?.toLowerCase().includes(search?.toLowerCase() || '')
    );
  }

  clearAllInResource(resourceObj:any,searchString:any){
    for (const block of Object.keys(resourceObj)) {
      if(Array.isArray(resourceObj[block])) {
        for (const resource of resourceObj[block]) {
          if (!searchString || resource.resourceName?.toLowerCase().includes(searchString.toLowerCase())) {
            for (const action of resource.actionsInfo || []) {
              action.isAssigned = false;
              this.deleteResource.push(action.resourceActionId);
            }
          }
        }
      }
    }
  }

  selectAllInResource(resourceObj:any,searchString:any){
    for (const block of Object.keys(resourceObj)) {
      if(Array.isArray(resourceObj[block])) {
        for (const resource of resourceObj[block]) {
          if (!searchString || resource.resourceName?.toLowerCase().includes(searchString.toLowerCase())) {
            for (const action of resource.actionsInfo || []) {
              // Set the action as assigned
              action.isAssigned = true;
              
              // Remove this resourceActionId from deleteResource if present
              const index = this.deleteResource.indexOf(action.resourceActionId);
              if (index !== -1) {
                this.deleteResource.splice(index, 1);
              }
            }
          }
        }
      }
    }
  }

  resourceToggle(type: any,resourceId: any, actionId: any,resourceItem?:any) {
    const resource = this.resourceList[type].find((res: any) => res.resourceId === resourceId);
    if (resource) {
      const action = resource.actionsInfo.find((action: any) => action.actionId === actionId);
      if (action) {
        const isAssigned = !action.isAssigned;
        action.isAssigned = isAssigned;
        const resourceActionId = action.resourceActionId;
        if (!isAssigned) {
          this.deleteResource.push(resourceActionId);
        } else {
          const index = this.deleteResource.indexOf(resourceActionId);
          if (index !== -1) {
            this.deleteResource.splice(index, 1);
          }
        }
      }
    }else{
       const action = resourceItem.actionsInfo.find((action: any) => action.actionId === actionId);
      if (action) {
        const isAssigned = !action.isAssigned;
        action.isAssigned = isAssigned;
        const resourceActionId = action.resourceActionId;
        if (!isAssigned) {
          this.deleteResource.push(resourceActionId);
        } else {
          const index = this.deleteResource.indexOf(resourceActionId);
          if (index !== -1) {
            this.deleteResource.splice(index, 1);
          }
        }
      }
    }
  }

  updateGlobalCheck() {
    this.globalResourceCheck = this.resourceList.every((a: { [x: string]: any; }, _: any, [b]: any) => a["enabled"] === b["enabled"]) &&
      this.resourceList && this.resourceList.length && this.resourceList[0]["enabled"]? true: false;
  }

  update() {

    //? Enable this and the below if statement if you want the condition
    //? that atleast one resource should be selected for a role definition
    // let isAtleastOneResourceSelected = this.resourceList.some(item => item.enabled);

    let metaInfo = {
      roleName: this.profileData.firstName,
      description: this.profileData.description ? this.profileData.description : null,
      status: true,
      applicationId: this.profileData.selectedApplication
    }


    //* Get the resource action ids for those resources
    //* where atleast one action is selected
    let finalResult = this.storeRsrcActionIds();
    
    let deletedIds = this.initialResourceActionIds.filter(
      (x: any) => !finalResult.includes(x) || this.initialApplicationId != this.profileData.selectedApplication
    );
    
    let newlyAddedIds = finalResult.filter((x) => !this.initialResourceActionIds.includes(x));    

    //* Application has been changed in the dropdown
    //* Hence move the resources of initial application to
    //* deleted resource action ids
    if (this.initialApplicationId !== this.profileData.selectedApplication) {
      deletedIds = [...deletedIds, ...this.initialResourceActionIdsBackup];
    } else {
      console.log("Application not changed");
    }

    let isMetaInfoChanged = this.getMetaInfoStr(this.profileData) !== this.getMetaInfoStr(metaInfo) ? true : false;

    let metaInfoDetails = isMetaInfoChanged ? metaInfo : null;

    // flag to make  API call to update application publish status if resources are added or deleted
    const ShouldUploadApplication = newlyAddedIds.length > 0 || deletedIds.length > 0;

    const details = {
      operation: USER_MGMT_CNST.OPERATION_TYPES.PROFILE.EDIT_PROFILE,
      postData: {
      role_id: this.roleId,
      addResourceActions: newlyAddedIds && newlyAddedIds.length > 0 ? newlyAddedIds : [],
      deleteResourceActions: this.initialApplicationId !== this.profileData.selectedApplication? deletedIds: this.deleteResource,
      meta: metaInfoDetails,
      roleDetailsJson: {
        validScopes: (this.updatedRoleScope.length < 0 || !this.updatedRoleScope) ?
        this.initScope : this.updatedRoleScope
      }
      },
    };
    this.updateProfile(details.postData,ShouldUploadApplication);
  }

  storeRsrcActionIds(valueInside: boolean = false) {
    const list: any[] = [];
    
    //* Iterate over each resource for the application.For each resource
    //* push only the resource action id where the READ / EDIT action is enabled
    Object.keys(this.resourceList).forEach((item: any) => {
      this.resourceList[item].forEach((resource: any) => {
        if(resource && resource?.resourceId) {          
          const index = this.mappedResourcesListToRole.findIndex((res: any) => res.resourceId == resource.resourceId);
          if(valueInside) {
            if(index != -1) {
              resource['actionsInfo'].forEach((action: any) => {
                if(action['isAssigned']) {
                  list.push(action['resourceActionId']);
                }
              })
            }
          }else {
            // if(index == -1) {
              resource['actionsInfo'].forEach((action: any) => {
                if(action['isAssigned']) {
                  list.push(action['resourceActionId']);
                }
              })
            // } 
          }
          
        } else if(resource && resource?.pages){
          resource.pages.forEach((page: any) => {
            const index = this.mappedResourcesListToRole.findIndex((res: any) => res.resourceId == page.resourceId);
            if(valueInside) {
              if(index != -1) {
                page.actionsInfo.forEach((action: any) => {
                  if(action['isAssigned']) {
                    list.push(action['resourceActionId']);
                  }
                })
              }
            }else {
              // if(index == -1) {
                page.actionsInfo.forEach((action: any) => {
                  if(action['isAssigned']) {
                    list.push(action['resourceActionId']);
                  }
                })
              // }
            }
          });

          resource.forms.forEach((form: any) => {
            const index = this.mappedResourcesListToRole.findIndex((res: any) => res.resourceId == form.resourceId);
            if(valueInside) {
              if(index != -1) {
                form.actionsInfo.forEach((action: any) => {
                  if(action['isAssigned']) {
                    list.push(action['resourceActionId']);
                  }
                })
              }
            }else {
              // if(index == -1) {
                form.actionsInfo.forEach((action: any) => {
                  if(action['isAssigned']) {
                    list.push(action['resourceActionId']);
                  }
                })
              // }
            }
          });

        } else if(resource && resource?.Widgets) {

          resource.Widgets.forEach((widget: any) => {
            const index = this.mappedResourcesListToRole.findIndex((res: any) => res.resourceId == widget.resourceId);
            if(valueInside) {
              if(index != -1) {
                widget.actionsInfo.forEach((action: any) => {
                  if(action['isAssigned']) {
                    list.push(action['resourceActionId']);
                  }
                })
              }
            }else {
              // if(index == -1) {
                widget.actionsInfo.forEach((action: any) => {
                  if(action['isAssigned']) {
                    list.push(action['resourceActionId']);
                  }
                })
              // }
            }
          });
        }
      })
    });
    return list;
  }

  

  getMetaInfoStr(userInfo: any) {
    if(!userInfo) return '';

    return JSON.stringify({
      applicationId: userInfo.applicationId,
      description: userInfo.description,
      roleName: userInfo.roleName,
      status: userInfo.status
    })
  }

  setPostAndOptions(profileInfo: any) {

    if (!profileInfo) {
      return { postData: null, options: null };
    }

    const { addResourceActions, deleteResourceActions, meta, roleDetailsJson } = profileInfo;

    if (!addResourceActions.length && !deleteResourceActions.length && !meta && !roleDetailsJson) {
      return { postData: null, options: null };
    }

    let postData: any = {
      addResourceActions,
      deleteResourceActions
    }

    if (profileInfo.meta) {
      postData.meta = profileInfo.meta;
    }

    if (roleDetailsJson) {
      postData.roleDetailsJson = roleDetailsJson
    }

    return {
      postData,
      options: {
        replaceParams: {
          "REPLACE_ROLE_ID": profileInfo.role_id
        }
      }
    }
  }

  updateProfile(profileInfo: any,shouldUpdateApplication?: boolean) {
    const { postData, options } = this.setPostAndOptions(profileInfo);

    if (postData && options) {
      this.loading = true;
      this.httpSrv.makePutApiCall("UPDATE_PROFILE", postData, this.envService.baseUrl, options).subscribe({
        next:async (response: any) => {
          this.appStateSrv.setWasPageScrolled(false);
          this.utilsSrv.showToastMessage(response.message, "success");
          if (shouldUpdateApplication && this.profileData.selectedApplication && !this.productStandardAppsIds.includes(this.profileData.selectedApplication)) {
            await this.updateApplication(profileInfo);
          }
          if( this.currentTab == 'info') {
            this.router.navigate(['um', 'roles', 'config'], {
              queryParams: {
                config: 'resources',
                title:this.title == 'add' ? 'add' :'edit'
              },
              queryParamsHandling: 'merge'
            })
          } else if( this.currentTab == 'resources') {
            this.router.navigate(['um', 'roles', 'config'], {
              queryParams: {
                config: 'scope',
                title:this.title == 'add' ? 'add' :'edit'
              },
              queryParamsHandling: 'merge'
            })
          }
          else {
            this.navigateToProfilesList();
          }
        },
        complete: () => {this.loading = false;},
        error: () => {
          this.loading = false;
          this.utilsSrv.showToastMessage("Error occured while updating role", "error");
        }
      });
    } else {
      this.utilsSrv.showToastMessage("No field is edited for updating","error");
    }
  }

  updateApplication(profileInfo: any) {
    const postData = {
    application_id: profileInfo.meta.applicationId,
    }
      this.loading = true;
      this.httpSrv.makePostApiCall("EDIT_APPLICATION", postData, this.envService.product_baseUrl).subscribe({
        complete: () => {this.loading = false;},
        error: () => {
          this.utilsSrv.showToastMessage("Error occured while updating application", "error");
        }
      });
  }

  checkValidScope(event:any){
    this.isScopeValid = event;
  }

  scopeDefinationScreen() {
    this.router.navigate(['um', 'roles', 'config'], {
      queryParams: {
        config: 'scope'
      },
      queryParamsHandling: 'merge'
    })
  }

  updateScope(data: any) {
    this.updatedRoleScope = data;
  }

  navigateToProfilesList() {
    this.router.navigate(['um', 'roles']);
  }

  nvaigateToEdit() {
    this.router.navigate(['um', 'roles', 'config'], {
      queryParams: {
        operation: 'edit'
      },
      queryParamsHandling: 'merge'
    })
  }
  moveToStep(index: number) {
    this.stepper.selectedIndex = index;
  }
}
